import { render } from "./formatCurrency.vue?vue&type=template&id=547d4db7"
import script from "./formatCurrency.vue?vue&type=script&lang=js"
export * from "./formatCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__